// src/authConfig.js
const isProduction = window.location.hostname !== 'localhost';
const redirectUri = isProduction
  ? window.location.origin
  : "http://localhost:5173/";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_EXTERNAL_CLIENT_ID || "ccacb34f-a749-4537-9ce3-a08d35c8954e",
    authority: `https://esaicustomers.ciamlogin.com/${import.meta.env.VITE_EXTERNAL_TENANT_ID || "aefb6bfa-3d6d-4e2a-8831-32a6353074d3"}`,
    redirectUri: redirectUri
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"]
};
